import {
  Select,
  SelectContent,
  SelectItem,
  SelectTrigger,
  SelectValue,
} from '@/components/ui/select';

type Props = {
  value: string;
  onValueChange: (value: string) => void;
  isTable?: boolean;
};

const StatusDropdown: React.FC<Props> = ({
  value,
  onValueChange,
  isTable = false,
}) => {
  // Define the color mapping based on the status
  const getStatusColor = (status: string) => {
    switch (status) {
      case 'Awaiting Collection':
        return '#720B6D'; // Purple
      case 'Payment Deposited':
        return '#40B822'; // Green
      case 'Payment Collected':
        return '#679EF1'; // Blue
      case 'Blocked':
        return '#383838'; // Grey
      default:
        return '#979797'; // Default color (grey) for placeholder or "all"
    }
  };

  return (
    <Select onValueChange={onValueChange} defaultValue={value}>
      <SelectTrigger
        className={`
          ${isTable ? `text-[${getStatusColor(value)}]` : 'text-[#979797]'}
          font-medium mr-2 border-none bg-transparent flex justify-between rounded-[5px] px-3 py-1 text-sm 
        `}
      >
        <SelectValue placeholder='Status' />
      </SelectTrigger>
      <SelectContent>
        {!isTable && <SelectItem value='all'>All</SelectItem>}
        <SelectItem value='Awaiting Collection' className='text-[#720B6D]'>
          Awaiting Collection
        </SelectItem>
        <SelectItem value='Payment Collected' className='text-[#679EF1]'>
          Payment Collected
        </SelectItem>
        <SelectItem value='Payment Deposited' className='text-[#40B822]'>
          Payment Deposited
        </SelectItem>

        <SelectItem value='Blocked' className='text-[#383838]'>
          Blocked
        </SelectItem>
      </SelectContent>
    </Select>
  );
};

export default StatusDropdown;
